import StepSolvingProblem from './StepSolvingProblem';

export default StepSolvingProblem;
